import { FrameComponent } from "../../common/FrameComponent";
import { AI_CASES_LINK } from "../../common/Header/constants";
import { useServiceUrl } from "../../common/hooks/use-service-url";

interface Props {
  className?: string;
}

export const AiCases = ({ className }: Props) => {
  const src = useServiceUrl(AI_CASES_LINK, "login");
  return <FrameComponent src={src} />;
};
